import React from "react";
import { doc, getDoc, onSnapshot, collection } from "firebase/firestore";
import { db } from "../database/firebase";
import { useEffect, useState } from "react";
import { auth } from "../database/firebase";
import { useAuth } from "../contexts/AuthContext";
import bgimage from "../assets/alumnobg.png";
import Cartel from "../component/Cartel"; // Importamos el componente Cartel

const Alumno = () => {
  const [clasesGrabadas, setClasesGrabadas] = useState([]);
  const [clasesRealtime, setClasesRealtime] = useState([]);
  const [userData, setUserData] = useState(null);
  const [sortAsc, setSortAsc] = useState(false);
  const { currentUser } = useAuth();
  const userRole = currentUser ? currentUser.rol : null;

  useEffect(() => {
    const fetchUserData = async () => {
      const userDoc = doc(db, "usuarios", auth.currentUser.uid);
      const userData = await getDoc(userDoc);
      setUserData(userData.data());
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    const fetchClases = () => {
      const claseGrabadaDoc = doc(db, "contenidoClases", "claseGrabadaDoc");
      const claseGrabadaCollection = collection(
        claseGrabadaDoc,
        "claseGrabada"
      );
      onSnapshot(claseGrabadaCollection, (snapshot) => {
        let newClaseGrabadaData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));

        if (sortAsc) {
          newClaseGrabadaData = newClaseGrabadaData.sort(
            (a, b) => a.timestamp - b.timestamp
          );
        } else {
          newClaseGrabadaData = newClaseGrabadaData.sort(
            (a, b) => b.timestamp - a.timestamp
          );
        }

        setClasesGrabadas(newClaseGrabadaData);
      });

      const claseRealtimeDoc = doc(db, "contenidoClases", "claseRealtimeDoc");
      const claseRealtimeCollection = collection(
        claseRealtimeDoc,
        "claseRealtime"
      );
      onSnapshot(claseRealtimeCollection, (snapshot) => {
        const newClaseRealtimeData = snapshot.docs.map((doc) => {
          const fecha = doc.data().fecha.toDate();
          const fechaStr = fecha.toLocaleDateString();
          const horaStr = fecha.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }); // formato de 24 horas sin segundos
          return {
            ...doc.data(),
            id: doc.id,
            fecha: fechaStr,
            hora: horaStr,
            timestamp: doc.data().timestamp,
          };
        });
        newClaseRealtimeData.sort((a, b) => b.timestamp - a.timestamp);
        setClasesRealtime(newClaseRealtimeData);
      });
    };

    fetchClases();
  }, [sortAsc]);

  console.log(clasesGrabadas === null ? "Cargando..." : clasesGrabadas);
  console.log(clasesRealtime === null ? "Cargando..." : clasesRealtime);

  return (
    <div class="relative min-h-screen">
      <div
        class="absolute inset-0 bg-repeat bg-center opacity-10"
        style={{
          backgroundImage: `url(${bgimage})`,
        }}
      ></div>
      <div class="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        {" "}
        {/* Usamos un contenedor con un ancho máximo y un padding horizontal para centrar el contenido */}
        {userRole !== "admin" && (!userData || !userData.clase_grabada) && (
          <div class="flex justify-center mt-12">
            {" "}
            {/* Usamos flexbox para alinear los elementos horizontalmente */}
            <p class="text-white text-center font-bold text-2xl sm:text-3xl lg:text-4xl leading-tight border-2 border-gray-700 rounded-2xl overflow-hidden bg-gray-700 px-4 py-6">
              {" "}
              {/* Usamos los prefijos de los puntos de corte para cambiar el tamaño del texto según la resolución de pantalla */}
              ¡Todavía no compraste las clases grabadas!
            </p>
          </div>
        )}
        {(userRole === "admin" || (userData && userData.clase_grabada)) &&
          clasesGrabadas.length === 0 && (
            <div class="flex justify-center mt-12">
              <p class="text-white text-center font-bold text-2xl sm:text-3xl lg:text-4xl leading-tight border-2 border-gray-700 rounded-2xl overflow-hidden bg-gray-700 px-4 py-6">
                Todavía no hay clases grabadas
              </p>
            </div>
          )}
        {clasesGrabadas.length > 0 && (
          <div class="flex flex-col items-center justify-center">
            <p class="text-white text-center font-bold text-2xl sm:text-3xl lg:text-4xl leading-tight border-2 border-gray-700 rounded-2xl overflow-hidden bg-gray-700 px-4 py-6 mt-12 hover:cursor-default">
              Contenido subido
            </p>
            <div class="text-white text-center font-bold text-xl sm:text-2xl lg:text-3xl leading-tight rounded-2xl overflow-hidden bg-gray-700 px-2 py-4 mt-4 hover:bg-gray-600 hover:shadow-btn-shadow hover:shadow-gray-600/25 transition-all duration-300">
              <button
                type="button"
                onClick={() => setSortAsc(!sortAsc)}
                class="flex items-center"
              >
                Cambiar orden:
                <svg
                  className={`w-6 h-6 text-white ml-2 mr-1 transition-transform duration-500 ${
                    sortAsc ? "rotate-180" : ""
                  }`}
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m5 15 7-7 7 7"
                  />
                </svg>
              </button>
            </div>
          </div>
        )}
        <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 mt-8">
          {" "}
          {/* Usamos el sistema de rejilla de Tailwind para crear una cuadrícula de columnas responsiva */}
          {clasesGrabadas.map((clase) => (
            <div class="bg-black/50 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl">
              <div class="aspect-w-16 aspect-h-9 w-full h-[220px] overflow-hidden rounded-t-2xl relative">
                {" "}
                {/* Usamos la clase aspect para mantener la proporción de los videos */}
                <iframe
                  class="embed-responsive-item border-0 rounded-xl w-full h-full aspect-w-16 aspect-h-9"
                  src={clase.link}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; 
                  autoplay; 
                  clipboard-write; 
                  encrypted-media; 
                  gyroscope; 
                  picture-in-picture; 
                  web-share;
                  fullscreen"
                ></iframe>
              </div>
              <div class="p-4">
                <h1 class="text-white font-bold text-xl sm:text-2xl lg:text-3xl mb-2 mr-4 leading-tight tracking-tight">
                  {clase.titulo}
                </h1>
                <div class="max-h-[100px] overflow-y-auto scrollbar scrollbar-thumb-rounded-full scrollbar-thumb-[#4a8ded] scrollbar-track-[#444b5d] scrollbar-track-rounded">
                  <span class="text-white/60 text-sm sm:text-base lg:text-lg leading-normal mr-4 mb-2 max-w-full whitespace-pre-line break-words">
                    {clase.descripcion}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div class="border-t border-white/10 mx-4 sm:mx-6 lg:mx-8 mt-8 mb-8"></div>
        {userRole !== "admin" && (!userData || !userData.clase_online) && (
          <div class="flex justify-center">
            <p class="text-white text-center font-bold text-2xl sm:text-3xl lg:text-4xl leading-tight border-2 border-gray-700 rounded-2xl overflow-hidden bg-gray-700 px-4 py-6 mb-8">
              ¡Todavía no compraste las clases 1 a 1!
            </p>
          </div>
        )}
        {(userRole === "admin" || (userData && userData.clase_online)) &&
          clasesRealtime.length === 0 && (
            <div class="flex justify-center">
              <p class="text-white text-center font-bold text-2xl sm:text-3xl lg:text-4xl leading-tight border-2 border-gray-700 rounded-2xl overflow-hidden bg-gray-700 px-4 py-6 mb-8">
                Todavía no hay clases 1 a 1
              </p>
            </div>
          )}
        {clasesRealtime.length > 0 && (
          <div class="flex flex-col items-center justify-center">
            <p class="text-white text-center font-bold text-2xl sm:text-3xl lg:text-4xl leading-tight border-2 border-gray-700 rounded-2xl overflow-hidden bg-gray-700 px-4 py-6">
              Clases próximas
              <p class="text-white text-center font-bold text-2xl">
                (Mas nuevas primero)
              </p>
            </p>
          </div>
        )}
        <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 mt-8">
          {clasesRealtime.map((clase) => (
            <div class="bg-black/50 rounded-2xl overflow-hidden shadow-lg pt-4">
              <div class="flex justify-center items-center">
                <Cartel fecha={clase.fecha} />{" "}
              </div>
              <div class="p-4 flex flex-col justify-center items-center">
                {clase.alumno && (
                  <span class="text-white font-bold text-xl sm:text-2xl lg:text-3xl tracking-tight border-2 border-gray-700 rounded-2xl overflow-hidden bg-gray-700 px-4 py-2 mb-2">
                    Alumno: {clase.alumno}
                  </span>
                )}
                <span class="text-white font-bold text-xl sm:text-2xl lg:text-3xl tracking-tight border-2 border-gray-700 rounded-2xl overflow-hidden bg-gray-700 px-4 py-2 mb-2">
                  Fecha: {clase.fecha}
                </span>
                <span class="text-white font-bold text-xl sm:text-2xl lg:text-3xl tracking-tight border-2 border-gray-700 rounded-2xl overflow-hidden bg-gray-700 px-4 py-2 mb-2">
                  Horario: {clase.hora}
                </span>
                <div class="border-2 border-gray-700 rounded-2xl overflow-hidden bg-gray-700 mb-2">
                  <div class="border-1 border-gray-800 rounded-md overflow-hidden bg-gray-800">
                    <a href={clase.link} target="_blank" rel="noreferrer">
                      <button class="btn bg-btnblue rounded-[4px] p-18 text-white font-bold ml-auto py-4 px-14 shadow-btn-shadow shadow-btnblue/25 w-full hover:bg-[#2d7bd9] hover:text-xl transition-all duration-300">
                        Ir a la clase
                      </button>
                    </a>
                  </div>
                </div>
              </div>
              <div class="p-4">
                <h1 class="text-white font-bold text-xl sm:text-2xl lg:text-3xl mb-2 mr-4 leading-tight tracking-tight">
                  {clase.titulo}
                </h1>
                <div class="max-h-[100px] overflow-y-auto scrollbar scrollbar-thumb-rounded-full scrollbar-thumb-[#4a8ded] scrollbar-track-[#444b5d] scrollbar-track-rounded">
                  <span class="text-white/60 text-sm sm:text-base lg:text-lg leading-normal mr-4 mb-2 max-w-full whitespace-pre-line break-words">
                    {clase.descripcion}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Alumno;
